// import { Workbox } from 'workbox-window';
export class BrowserServiceWorker {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    async registerServiceWorker() {
        const { Workbox } = await import('workbox-window');
        const wb = new Workbox('/service-worker2.js');
        wb.addEventListener('activated', event => {
            // `event.isUpdate` will be true if another version of the service
            // worker was controlling the page when this version was registered.
            if (!event.isUpdate) {
                console.log('Service worker activated for the first time!');
                // If your service worker is configured to precache assets, those
                // assets should all be available now.
            }
        });
        wb.addEventListener('waiting', event => {
            console.log("A new service worker has installed, but it can't activate until all tabs running the current version have fully unloaded.");
        });
        wb.register();
        const swVersion = await wb.messageSW({ type: 'GET_VERSION' });
        console.log('Service Worker version:', swVersion);
    }
}
